import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import BugBustersImg from "../../assets/event-images/bug-busters.jpg";

const blindCoding = {
  image: BugBustersImg,
  description:
    'Blind coding challenge the participants to write code without running or testing it during the competition.  Test cases are hidden, and no instant feedback or debugging tools are allowed.',
  type: "Technical Event",
  eventName: "Blind Coding",
  dateTime: "February 28, 2.30PM - 4.00PM",
  venue: "IT-442",
  rules: [
    "Solo participation",
    "Single Round: One round with 3 questions:Easy (Basic),Medium (Intermediate),Hard (Advanced)",
    "Participants cannot see the test cases.",
    "Participant can only submit the solution without running it against the actual test cases.", 
    "Code can be written in any programming language.",
    "The participant whose code successfully solves the highest number of test cases during evaluation will be declared the winner.",
],
  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Kamaliha",
      phoneNo: "9943658157",
    },
    {
      name: "Thiageshwaran S",
      phoneNo: "9080513837",
    },
  ],
};

const BlindCoding = () => {
  return <SingleEventPage eventDetails={blindCoding} />;
};

export default BlindCoding;
